import angular from 'angular';

var module = angular.module('app.gift-deets', []);

export default module;